// Site configuration - edit this file to change site settings

// Фиксированный путь админки - защита паролем настраивается на хостинге через .htpasswd
export const ADMIN_PATH = '/admin-panel';

// Функция для получения пути админки (для совместимости)
export const getAdminPath = (): string => ADMIN_PATH;

// Default language
export const DEFAULT_LANGUAGE = 'en';

// Supported languages
export const SUPPORTED_LANGUAGES = ['en', 'ua', 'ru', 'es', 'pt', 'fr', 'de'] as const;
export type SupportedLanguage = typeof SUPPORTED_LANGUAGES[number];

// Google Analytics ID (leave empty if not using)
export const GOOGLE_ANALYTICS_ID = '';

// Google AdSense ID (leave empty if not using)
export const GOOGLE_ADSENSE_ID = '';

// Site URL for SEO - теперь настраивается через админку
// Этот fallback используется только если не задано в админке
export const SITE_URL = typeof window !== 'undefined' ? window.location.origin : 'https://yoursite.com';

// OG Image path
export const OG_IMAGE_PATH = '/og-image.jpg';
